import rootPath, { RouteProps as BaseRouteProps } from "../routes-path";

export interface RouteProps extends BaseRouteProps {
    clubId: string;
}

export default rootPath + "/:clubId";